import React, {Component} from "react";
import PanelGroup from "./PanelGroup";

class PanelGroupController extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded
    }
    this.handleToggleContent = this.handleToggleContent.bind(this);
  }

  render() {
    let {expanded, ...keepProps} = this.props;
    return (
      <PanelGroup 
        onToggleContent={this.handleToggleContent}
        expanded={this.state.expanded}
        {...keepProps} 
        />
    )
  }

  handleToggleContent() {
    this.setState({expanded: !this.state.expanded});
  }
}

PanelGroupController.defaultProps = {
  expanded: true
}

export default PanelGroupController;